import { gatsbySSR } from '@lib/ui';
import Theme from './src/Theme';

const { onRenderBody, wrapRootElement } = gatsbySSR(Theme);

export { onRenderBody, wrapRootElement };
